import React from "react" ;
import MyContributorsAppBodyHeader from "./MyContributorsAppBodyHeader";
import {Route, Switch} from "react-router-dom";
import {PATH_MY_CONTRIBUTORS_ROOT, PATH_MY_CONTRIBUTOR_SUMMARY} from "root/Wieldy/routePaths";
import ScrollRails from "../../Common/Body/ScrollRails";
import MyContributorsTab from "root/Wieldy/ApplicationModules/MyContributors/Body/MyContributorsTab";
import UsersDashboardTab from "root/Wieldy/ApplicationModules/Users/Body/UserDashboards/UsersDashboardTab";

const MyContributorsAppBody= (props) =>
{
    return (
    <div className="dt-module__container">
        <MyContributorsAppBodyHeader />
        <div className="dt-module__content ps-custom-scrollbar ps" style={{height: props.height, width: props.width}}>
            <div className="dt-module__content-inner">
                <div className="dt-module__list">
                    <Switch>
                        <Route path={PATH_MY_CONTRIBUTOR_SUMMARY} render={(thisprops) => <UsersDashboardTab {...thisprops}/>}/>
                        <Route path={PATH_MY_CONTRIBUTORS_ROOT} render={(thisprops) => <MyContributorsTab user_id='' {...thisprops}/>}/>
                    </Switch>
                </div>
            </div>
            <ScrollRails />
        </div>
    </div>
    ) ;
}

export default MyContributorsAppBody;
